export enum ChatThreadTypeEnum {
  DEFAULT = 1,
  STUDENT_TEACHER,
  STUDENT_PARENT_TEACHER,
  TEACHER_PARENT
}
